import React from 'react';
import styled from 'styled-components';
import Subject from '../../Components/Subject';

import linkMainImg from '../../assets/img/product/link/linkMainImg.png';
import SpecSection from './productComponents/SpecSection';
import HeaderContents from './productComponents/HeaderContents';
import DividingPattern from './productComponents/DividingPattern';
import DividingDesc from './productComponents/DividingDesc';
import DividingImg from './productComponents/DividingImg';
import BottomRail from './productComponents/BottomRail';
import DesignDesc from './productComponents/DesignDesc';
import ProductQuility from './productComponents/ProductQuility';

import ProcessSection from './productComponents/ProcessSection';
import Neccessary from './productComponents/Neccessary';
import { linkData, linkInfo } from './productData';
import ProductHeader from './ProductHeader';

const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  @media (max-width: 1280px) {
    width: 100%;
    padding: 0 20px 50px 20px;
  }
`;

const Box = styled.div`
  width: 100%;
`;

const Row = styled.div`
  > img {
    width: 100%;
  }
`;

const Link = () => {
  return (
    <>
      <ProductHeader />
      <Container>
        <Subject info={linkInfo} />
        <Box>
          <Row>
            <img src={linkMainImg} alt="linkMainImg" />
          </Row>
          <HeaderContents info={linkInfo} />
          <DividingPattern info={linkInfo} />
          <DividingDesc
            title={linkInfo.dividingTitle}
            data={linkInfo.dividingDesc}
          />
          <DividingImg info={linkInfo.dividingBarImgs} />
          <BottomRail info={linkInfo} />
          <DesignDesc title={linkInfo.designTitle} data={linkInfo.designDesc} />
          {linkData.map((data, index) => (
            <SpecSection data={data} key={index} />
          ))}
          <ProcessSection />
          <Neccessary />
          <ProductQuility imgs={linkInfo.bottomImgs} />
        </Box>
      </Container>
    </>
  );
};

export default Link;
